/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { RfqStructureRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { Observable } from 'rxjs';
import { RfqHeadingListItem } from './rfq-structure.model';

@Injectable()
export class HeadingListBusinessService implements InitViewService {
  constructor(private rfqStructureRest: RfqStructureRestService) {

  }

  initView(): any {
    return {
      headingList: this.findAll(),
    };
  }

  findAll(): Observable<RfqHeadingListItem[]> {
    return this.rfqStructureRest.findAll();
  }

  update(headingList: RfqHeadingListItem[]): Observable<RfqHeadingListItem[]> {
    return this.rfqStructureRest.update(headingList);
  }
}
